
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import DropdownButton from './DropdownButton.vue';
import DropdownItem from './DropdownItem.vue';

@Component({
	components: {
		DropdownButton,
		DropdownItem,
	},
})
export default class DropdownNew extends Vue {

	@Prop({ type: Boolean, default: false })
	readonly isDropdown!: boolean;

	isOpen = false;

	@Watch('isOpen')
	closeDropdownChange(isOpen: boolean): void {
		if (!isOpen) {
			document.removeEventListener('click', this.closeDropdown);
		} else {
			document.addEventListener('click', this.closeDropdown);
		}
	}

	@Watch('isDropdown')
	isDropdownChange() {
		this.selectOption();
	}

	toggleDropdown(): void {
		this.isOpen = !this.isOpen;
	}

	selectOption(option?: string): void {
		this.isOpen = false;
	}

	closeDropdown(event: MouseEvent): void {
		if (!(this.$refs.dropdown as HTMLElement).contains(event.target as Node)) {
			this.isOpen = false;
		}
	}

	mounted(): void {
		document.addEventListener('click', this.closeDropdown);
	}

	beforeDestroy(): void {
		document.removeEventListener('click', this.closeDropdown);
	}
}
